/**
 * The research data api.
 */
export default class Research {
    /**
     * Create by options.
     * @param options - such as api manager or  security manager.
     */
    constructor(options) {
        this.securityManager = options.securityManager;
        this.apiManager = options.apiManager;
    }

    /**
     * Get research highlights data.
     * This method will convert security to symbol and mic code(exchange id)by id service.
     * @param params - some parameters collection, you can use security.
     * @param params.security - A valid security could be performance id, security id, exch:symbol, realtime id.
     * @returns {Promise}
     */
    async getResearchHighlights(params) {
        const securities = await this.securityManager.create(params.security);
        if (securities.length === 1) {
            const security = securities[0];
            return this.apiManager.getResearchHighlights({
                symbol: security.mstarSymbol,
                exchangeId: security.MICCode
            });
        } else {
            throw this.securityManager.getInvalidSecuritiesError(
                params.security
            );
        }
    }

    /**
     * Get research bulls vs bears data.
     * This method will convert security to symbol and mic code(exchange id)by id service.
     * @param params - some parameters collection, you can use security.
     * @param params.security - A valid security could be performance id, security id, exch:symbol, realtime id.
     * @returns {Promise}
     */
    async getResearchBullsVsBears(params) {
        const securities = await this.securityManager.create(params.security);
        if (securities.length === 1) {
            const security = securities[0];
            return this.apiManager.getResearchBullsVsBears({
                symbol: security.mstarSymbol,
                exchangeId: security.MICCode
            });
        } else {
            throw this.securityManager.getInvalidSecuritiesError(
                params.security
            );
        }
    }

    /**
     * Get research competitors data.
     * @param params - some parameters collection, you can use security.
     * @param params.security - A valid security could be performance id, security id, exch:symbol, realtime id.
     * @returns {Promise}
     */
    async getResearchCompetitors(params) {
        const securities = await this.securityManager.create(params.security);
        if (securities.length === 1) {
            const security = securities[0];
            return this.apiManager.getResearchCompetitors({
                secId: security.securityId
            });
        } else {
            throw this.securityManager.getInvalidSecuritiesError(
                params.security
            );
        }
    }
}
